/**
 * @generated SignedSource<<40db37da44bac15158155a37200a6fa0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingTypeInput = {
  data?: string | null | undefined;
  id?: string | null | undefined;
  is_locked?: boolean | null | undefined;
  name: string;
};
export type UpdateRemoteSettingMutation$variables = {
  input: SettingTypeInput;
};
export type UpdateRemoteSettingMutation$data = {
  readonly updateSetting: {
    readonly id: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"SettingFragment">;
  } | null | undefined;
};
export type UpdateRemoteSettingMutation = {
  response: UpdateRemoteSettingMutation$data;
  variables: UpdateRemoteSettingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateRemoteSettingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Setting",
        "kind": "LinkedField",
        "name": "updateSetting",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SettingFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateRemoteSettingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Setting",
        "kind": "LinkedField",
        "name": "updateSetting",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "is_locked",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "data",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "487c81734143ea4a5854bfbfafc1f6e3",
    "id": null,
    "metadata": {},
    "name": "UpdateRemoteSettingMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateRemoteSettingMutation(\n  $input: SettingTypeInput!\n) {\n  updateSetting(input: $input) {\n    id\n    ...SettingFragment\n  }\n}\n\nfragment SettingFragment on Setting {\n  id\n  name\n  is_locked\n  data\n}\n"
  }
};
})();

(node as any).hash = "2f4f2bd993d21005222f7adb02ba788d";

export default node;
